import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import StatusText from '../components/StatusText';
import LoginView from '../views/LoginView';
import HomeView from '../views/HomeView';
import BookView from '../views/BookView';
import PageNotFoundView from '../views/PageNotFoundView';
import RedirectToPNFView from '../views/RedirectToPNFView';
import {requireAuthentication} from '../views/AuthenticatedView';

class App extends Component {
   render() {
      return (
         <MuiThemeProvider>
            <div>
               <Switch>
                  <Route exact path="/" component={requireAuthentication(HomeView)}/>
                  <Route path="/login" component={LoginView}/>
                  <Route exact path="/book/:bookKey" component={requireAuthentication(BookView)}/>
                  <Route path="/book/:bookKey/article/:articleKey" component={requireAuthentication(BookView)}/>
                  <Route path="/pageNotFound" component={PageNotFoundView}/>
                  <Route component={RedirectToPNFView}/>
               </Switch>
               <StatusText/>
            </div>
         </MuiThemeProvider>
      );
   }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js